<template>
    <v-dialog class="force-premium-dialog" :value="isBlocked" persistent no-click-animation transition="none" fullscreen fluid>
        <v-container fluid fill-height class="d-flex align-center justify-space-between flex-column force-premium-overlay">
            <div class="pa-6">
                <logo :link="false" height="40" />
            </div>
            <div class="px-2 pb-6">
                <h2 class="font-weight-medium text-center primary--text mb-6">التطبيق متاح للخطة المميزة فقط</h2>
                <p class="text-center grey--text medium-text">
                    لا يمكنك استخدام تطبيق منصة خانة ﻷنك لست مشتركاً بالخطة المميزة، يمكنك استخدام نسخة الويب، أو الاشتراك في الخطة المميزة لتممكن من استخدام التطبيقات!
                </p>
            </div>
            <div class="w-100 pa-4">
                <v-btn color="primary" block depressed large class="font-weight-bold mt-6" @click="openWeb">
                    <v-icon size="20" left>mdi-web</v-icon>
                    التوجه إلى نسخة الويب
                </v-btn>
            </div>
            <!-- <div class="primary--text medium-text" style="font-weight: 600"></div> -->
            <!-- <div class="icon-wrapper primary">
                <v-icon color="white" size="40">mdi-download</v-icon>
            </div> -->
        </v-container>
    </v-dialog>    
</template>
<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import Logo from '@/components/main/logo'
// import AppAPI from '@/app-api'

export default {
    data(){
        return {
            isBlocked: false,
        }    
    },
    components: {Logo},
    computed: {
        ...GlobalComputed,
        forcePremium(){
            return this.capRunning && this.appData.app_force_premium;
        },
        notAllowed(){
            return this.forcePremium && this.storeData && this.storeData.subscription !== 'premium';
        }
    },
    methods: {
        ...GlobalMethods,
        openWeb(){
            const url = 'https://seller.e-khanh.com';
            window.open(url, '_system');
            // return AppAPI.openUrl(url);
        },
    },
    watch: {
        notAllowed(value){
            this.isBlocked = value;
        }
    },
    mounted(){
        this.isBlocked = this.notAllowed;
    }
}
</script>
<style lang="scss" scoped>
    .force-premium-overlay{
        background-color: rgba(255, 255, 255, 0.92);
        z-index: 1000;
    }
    .icon-wrapper{
        width: 100px;
        height: 100px;
        border-radius: 50%;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;

        margin: 3rem auto;
    }
</style>
